
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { ESearchedPatientCard } from '@/entities/ESearchedPatientCard'
import { useReportCreation } from '@/widgets/WReportCreation/composables/useReportCreation'
import { PatientFilterType, PatientType } from '@/shared/types'
import { patientApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'

export default defineComponent({
  name: 'SearchPatient',

  components: {
    ESearchedPatientCard,
  },

  setup() {
    const route = useRoute()
    const { selectedPatient, setSelectedPatient } = useReportCreation()

    const isPatientSearched = ref(false)
    const searchingData = ref<string>()
    const patients = ref<PatientType[]>([])

    const getOptionLabel = (patient: PatientType): string => {
      return `${patient.surname} ${patient.name} ${patient.patronymic ?? ''}`
    }

    const getPatient = async (patientId: number): Promise<void> => {
      const [error, response] = await patientApi.getPatientInfo(patientId)

      if (error) {
        showErrorMessage(error)
      } else {
        setSelectedPatient(response.data.patient)
        isPatientSearched.value = true
      }
    }

    const setDefaultCreationMode = async (): Promise<void> => {
      const patientId = route.params.patientId

      if (patientId && patientId !== 'null-patient') {
        await getPatient(Number(patientId))
      }
    }

    const remotePatientSearch = async (query: string): Promise<void> => {
      if (!query) {
        patients.value = []

        return
      }

      const filterData: PatientFilterType = {
        dateFrom: undefined,
        dateTo: undefined,
        search: query,
      }

      const [error, response] = await patientApi.getPatientListing(filterData)

      if (error) {
        patients.value = []

        return
      }

      patients.value = response.data.patients.filter((patient) => {
        return (
          patient.surname.toLowerCase().includes(query.toLowerCase()) ||
          patient.cart_number.toString().includes(query)
        )
      })
    }

    const handleRemovePatient = (): void => {
      setSelectedPatient(undefined)

      isPatientSearched.value = false
      searchingData.value = ''
    }

    onMounted((): void => {
      setDefaultCreationMode()
    })

    return {
      selectedPatient,
      isPatientSearched,
      searchingData,
      patients,
      getPatient,
      getOptionLabel,
      remotePatientSearch,
      handleRemovePatient,
    }
  },
})
